<template>
  <transition name="el-fade-in-linear">
    <div class="index">
      <router-link to="/Solution">
        <img class="backPic" src="../../static/images/back.png" />
      </router-link>
      <div class="container">
        <img class="solutionDetailTitle1" src="../../static/images/solutionText5.png" />
        <br />
        <img class="solutionDetailTitle2" src="../../static/images/solutionText4.png" />
           <div class="solutionDetailThirdFlex">
          <div class="solutionDetailItem">
            <div class="solutionDetailSecondTitle">
              公共交通智慧安全立体防控平台
            </div>
            <div class="solutionDetailSecondText">
              对接高速公路各类感知设备及信息化系统，汇聚高速公路各类数据资源，利用云计算、大数据等现代化信息技术，搭建承载数据资产的大数据平台，基于多源异质异构数据处理技术，形成高速运营状况全时空多维分布“一张图”，对高速运营及安全情况进行实时监测和告警，及时启动应急预案，远程指挥调度，使高速公路管理更科学、指挥响应更迅速、交通事件感知更及时。
            </div>
          </div>
          <div class="solutionDetailItem">
            <img
              class="solutionDetailPic"
              src="../../static/images/solutionDetailPic6.jpg"
            />
          </div>
        </div>
        </div>
      </div>
      <div class="bottomFoot">
        <Foot />
      </div>
    </div>
  </transition>
</template>


<script>
import Foot from "./Foot";

export default {
  name: "Index",
  data() {
    return {};
  },
  components: {
    Foot,
  },
  mounted: function () {
    this.$router.afterEach((to, from, next) => {
      window.scrollTo(0, 0);
    });
  },
  methods: {},
};
</script>
<style scoped>
@import "./solutionDetail.css";
</style>



// WEBPACK FOOTER //
// src/views/SolutionDetail2.vue